import { makeStyles } from "@mui/styles";

export const Icon_useStyles = makeStyles({
  Icon: {
    "& .iconCon": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .icon": {
        width: "25px",
        height: "25px",
      },
      "& #menu": {
        cursor: "pointer",
      },
    },
  },
});
